<template>
    <div class="checklist">
        <div class="check-box-custom" v-for="(item, index) in items" :key="getKey(item, index)">
            <input
                type="checkbox"
                :id="`checkbox-${index}-${getValue(item)}`"
                :value="getValue(item)"
                :checked="modelValue.includes(getValue(item))"
                @change="handleChange($event, getValue(item))"
            >
            <label :for="`checkbox-${index}-${getValue(item)}`" class="data">
                {{ getValue(item) }}
            </label>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            required: true
        },
        modelValue: {
            type: Array,
            required: true
        },
        itemKey: {
            type: String,
            default: null
        }
    },
    emits: ['update:modelValue'],
    methods: {
        getValue(item) {
            // Si itemKey est fourni et que item est un objet
            if (this.itemKey && item && typeof item === 'object') {
                return item[this.itemKey];
            }
            // Sinon retourner l'item tel quel (string)
            return item;
        },
        getKey(item, index) {
            const value = this.getValue(item);
            return `${value}-${index}`;
        },
        handleChange(event, value) {
            const checked = event.target.checked;
            let newValue = [...this.modelValue];

            if (checked) {
                if (!newValue.includes(value)) {
                    newValue.push(value);
                }
            } else {
                newValue = newValue.filter(v => v !== value);
            }

            this.$emit('update:modelValue', newValue);
        }
    }
}
</script>

<style scoped lang="scss">
.checklist {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .check-box-custom {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 0px !important;
        border-radius: 4px;
        transition: background 0.2s ease;

        &:hover {
            background: #f5f5f5;
        }

        input[type="checkbox"] {
            width: 18px;
            height: 18px;
            cursor: pointer;
            accent-color: #ff8c00;
        }

        .data {
            font-size: 14px;
            color: #333;
            cursor: pointer;
        }
    }
}
</style>
